import React, { Component, useContext } from 'react';
import LowerHeader from '../../components/Header/LowerHeader/LowerHeader';
import PlusIcon from '../../components/Icons/PlusIcon';
import MinusIcon from '../../components/Icons/MinusIcon';
import Toolbar from '../../components/Header/Toolbar/Toolbar';
import { API_DOMAIN } from '../../EnvVars';
import Table from 'react-bootstrap/Table';
import { Accordion, Card } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import './DMSContainer.css';
import TickIcon from '../../components/Icons/TickIcon';
import UntickIcon from '../../components/Icons/UntickIcon';
import Api from '../../api/api';

class DMSContainer extends Component {
  dealerEP;
  constructor(props) {
    super(props);
    this.state = {
      authToken: localStorage.getItem('authToken'),
    };

    this.getDmsData();
  }

  getDmsData = async () => {
    try {
      const data = await Api.getDms();
      const dmsArr = data.map(dms => ({
        ...dms,
        needsToken: dms.needsToken ? dms.needsToken.toString().toUpperCase() : 'FALSE',
      }));
      this.setState({ dmsArr });
    } catch (error) {
      console.error(error);
    }
  };

  componentDidMount() {
    const { authToken } = this.state;
    if (!authToken) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    } else {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
          <Toolbar />
        </div>
        <div className="container-fluid text-center">
          <LowerHeader pageTitle="DMS" />
          <DMSDataTable dmsToggles={this.state.dmsArr} />
        </div>
      </React.Fragment>
    );
  }
}

function AccordionTogglePlusMinus(props) {
  const currentEventKey = useContext(AccordionContext); // <-- Will update every time the eventKey changes.

  const isCurrentEventKey = currentEventKey === props.eventKey;

  return (
    <Accordion.Toggle as={Card.Body} {...props}>
      {!isCurrentEventKey && <PlusIcon size="12" thick="2" />}
      {isCurrentEventKey && <MinusIcon size="12" thick="2" />}
    </Accordion.Toggle>
  );
}

/**
 * DMS Data Table definition.
 */
function DMSDataTable(props) {
  const { dmsToggles = [] } = props;
  return (
    <React.Fragment>
      <Table size="sm" bordered responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th style={{ width: '12%' }}>Enabled</th>
            <th style={{ width: '12%' }}>Deleted</th>
            <th style={{ width: '12%' }}>Require Token</th>
            <th style={{ width: '30%' }}>Features</th>
          </tr>
        </thead>

        <tbody className="dmsaccordion">
          {dmsToggles.map(row => (
            <ServiceRow row={row} key={row.name} />
          ))}
        </tbody>
      </Table>
    </React.Fragment>
  );
}

const BooleanCell = ({ val }) => {
  if (val === 'TRUE') return <TickIcon />;
  return <UntickIcon />;
};
const ServiceRow = ({ row = null }) => {
  return (
    <React.Fragment>
      <tr>
        <td>{row.name}</td>
        <td>
          <BooleanCell val={row.isEnabled} />
        </td>
        <td>
          <BooleanCell val={row.isDeleted} />
        </td>
        <td>
          <BooleanCell val={row.needsToken} />
        </td>
        <td>
          {
            <Accordion>
              <Card>
                <AccordionTogglePlusMinus eventKey={row.name} row={row} />
                <Accordion.Collapse eventKey={row.name}>
                  <Card.Body>
                    <Table size="sm" responsive>
                      <tbody>
                        {row.defaultFeatures.map(feature => (
                          <tr
                            key={feature.name}
                            className={feature.isEnabled === 'TRUE' ? 'rowHighlight' : ''}
                          >
                            <td style={{ textAlign: 'left' }}>{feature.name}</td>
                            <td>
                              <BooleanCell val={feature.isEnabled} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          }
        </td>
      </tr>
    </React.Fragment>
  );
};

export default DMSContainer;



// WEBPACK FOOTER //
// ./src/containers/DMS/DMSContainer.js